////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const exportDatas = {
	postExportDatas: (filters = {}, url = '') => ({
		type: ActionsTypes.POST_EXPORT_DATAS,
		payload: {
			filters,
			url,
		},
	}),
	postExportDatasSuccess: (data) => ({
		type: ActionsTypes.POST_EXPORT_DATAS_SUCCESS,
		payload: {
			data,
		},
	}),
	postExportDatasFailure: (error) => ({
		type: ActionsTypes.POST_EXPORT_DATAS_FAILURE,
		payload: {
			error,
		},
	}),
	postExportDatasByEmail: (filters = {}, url = '') => ({
		type: ActionsTypes.POST_EXPORT_DATAS_BY_EMAIL,
		payload: { filters, url },
	}),
	postExportDatasByEmailSuccess: () => ({
		type: ActionsTypes.POST_EXPORT_DATAS_BY_EMAIL_SUCCESS,
		payload: {},
	}),
	postExportDatasByEmailFailure: (error) => ({
		type: ActionsTypes.POST_EXPORT_DATAS_BY_EMAIL_FAILURE,
		payload: { error },
	}),
	resetExportDatasByEmail: () => ({
		type: ActionsTypes.RESET_EXPORT_DATAS_BY_EMAIL,
		payload: {},
	}),
}

export default exportDatas
